<template>
  <span
      :ref="iconRef"
      class="iconify"
      :data-icon="icon"
      :style="{
        'font-size': size,
        'color': disabled ? disabledColor : color
      }"
  ></span>
</template>

<script>
export default {
  name: "Iconify",
  props: {
    iconRef: {
      default: 'ico-' + Math.random().toString().slice(2)
    },
    icon: {
      default: ''
    },
    color: {
      default: '#3F3F3F'
    },
    size: {
      default: '20px'
    },
    disabled: {
      default: false
    },
    disabledColor: {
      default: 'var(--theme-color-nine)'
    }
  }
}
</script>

<style scoped>

</style>